module.exports = __webpack_public_path__ + "img/13.12ef3f6c.png";